import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="footer_small">
      <div className="container-full">
        <div className="link-holder">
          <a
            href="https://www.twitter.com/uselimahq"
            target="_blank"
            rel="noreferrer"
            className="footer-link text-size-xsmall"
          >
            X.com
          </a>
          <a href="https://uselima.com/pricing" className="footer-link text-size-xsmall">
            Pricing
          </a>
          <a
            href="https://uselima.com/contact"
            className="footer-link text-size-xsmall"
          >
            Contact
          </a>
          <Link to="/login" className="footer-link text-size-xsmall">
            Login
          </Link>
          <Link to="/signup" className="footer-link text-size-xsmall">
            Sign up
          </Link>
          <a
            href="https://uselima.com/frequently-asked-questions"
            className="footer-link text-size-xsmall"
          >
            FAQs
          </a>
          <a
            href="https://uselima.com/terms"
            className="footer-link text-size-xsmall"
          >
            Terms
          </a>
          <a
            href="https://uselima.com/privacy"
            className="footer-link text-size-xsmall"
          >
            Privacy
          </a>
        </div>
      </div>
    </footer>
  );
}

